import { BaseComponent } from "../BaseComponent";
import { ComponentNames } from 'src/app/helper/componentNames';

export class TableComponent extends BaseComponent{
    constructor(){
        super();
        this.componentType = ComponentNames.tableComponent;
    }
    socketAmount:number;
    tableLeg:boolean;
    foldingElement:boolean;
    pullOutElement:boolean;
}